import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import { LoaderProvider } from './context/LoaderContext';
import { ToastProvider } from "./context/ToastContext";
import GlobalLoader from './components/GlobalLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <LoaderProvider>
        <GlobalLoader />
        <App />
      </LoaderProvider>
    </ToastProvider>
  </React.StrictMode>
);
